"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductItemValueExcess = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excessHelper = require("../../../helpers/excessHelper");
var _productItemValueRadios = require("./productItemValueRadios");
var _labelPropTypes = require("../../productTableLabels/defaults/labelPropTypes");
var _tableContext = require("../../productsTable/stateHelpers/tableContext");
var _productHelpers = require("../../../helpers/productHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */

var ProductItemValueExcess = exports.ProductItemValueExcess = function ProductItemValueExcess(_ref) {
  var labelKey = _ref.labelKey,
    formContext = _ref.formContext,
    labelDefinition = _ref.labelDefinition,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    productDefinition = _ref.productDefinition,
    productGroup = _ref.productGroup,
    _ref$onRadioSelect = _ref.onRadioSelect,
    onRadioSelect = _ref$onRadioSelect === void 0 ? function () {} : _ref$onRadioSelect;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    AddOnsMap = _useContext$tableCont.AddOnsMap,
    AllPlans = _useContext$tableCont.AllPlans,
    BaseProducts = _useContext$tableCont.BaseProducts,
    brandTextElements = _useContext$tableCont.brandTextElements,
    _useContext$tableStat = _useContext.tableState,
    selectedOptions = _useContext$tableStat.selectedOptions,
    productsAreMerged = _useContext$tableStat.productsAreMerged,
    staffMode = _useContext$tableStat.staffMode,
    petSureStaffMode = _useContext$tableStat.petSureStaffMode;
  if (Object.keys(AllPlans).length === 0) {
    return null;
  }
  var label = labelDefinition.label,
    valueMap = labelDefinition.valueMap,
    formatters = labelDefinition.formatters,
    defaultValueIndex = labelDefinition.defaultValueIndex;
  var planNumber = productDefinition.planNumber;
  var HandleRadioSelect = function HandleRadioSelect(radioValue) {
    onRadioSelect({
      productDefinition: productDefinition,
      labelKey: labelKey,
      radioValue: radioValue,
      labelDefinition: labelDefinition
    });
  };
  var radioValues = (0, _excessHelper.FindAllExcessOptionsBasedOnAmount)({
    planNumber: planNumber,
    staffMode: staffMode,
    petSureStaffMode: petSureStaffMode,
    AddOnsMap: AddOnsMap,
    AllPlans: AllPlans,
    selectedOptions: selectedOptions,
    productGroup: productGroup,
    dynamicDependencies: labelDefinition === null || labelDefinition === void 0 ? void 0 : labelDefinition.dynamicDependencies
  }).sort(function (a, b) {
    if (a.value < b.value) {
      return -1;
    }
    return 1;
  });
  var selectedRadio = radioValues.find(function (radioValue) {
    var activeOptions = selectedOptions.merged ? selectedOptions : (0, _productHelpers.GetInitialPlanOptionsState)({
      BaseProducts: BaseProducts,
      AllPlans: AllPlans,
      brandTextElements: brandTextElements
    });
    if (productsAreMerged) {
      return radioValue.value.toString() === activeOptions.merged[productGroup].excess;
    }
    return radioValue.value.toString() === activeOptions.allPlans[planNumber].excess;
  }) || radioValues[defaultValueIndex];
  if (radioValues.length === 1) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "singleRadioValue"
    }, "$", selectedRadio.value);
  }
  return /*#__PURE__*/_react["default"].createElement(_productItemValueRadios.ProductItemValueRadios, {
    planNumber: planNumber,
    label: label,
    formContext: formContext,
    labelKey: labelKey,
    disabled: disabled,
    valueMap: valueMap,
    formatters: formatters,
    value: "".concat(selectedRadio.value),
    values: radioValues,
    defaultValueIndex: defaultValueIndex,
    onRadioSelect: HandleRadioSelect
  });
};
ProductItemValueExcess.propTypes = {
  labelKey: _propTypes["default"].string,
  labelDefinition: _propTypes["default"].shape(_labelPropTypes.LabelPropTypes),
  disabled: _propTypes["default"].bool,
  productDefinition: _propTypes["default"].any,
  productGroup: _propTypes["default"].string,
  onRadioSelect: _propTypes["default"].func,
  formContext: _propTypes["default"].any
};